import React from 'react';
import { Box } from '@common-fe/common-fe';

import PERMISSIONS from '@/common/permissions';
import ROUTES from '@/common/routes';
import { useHasAccess } from '@/modules/core';
import Topbar from '@/modules/core/components/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks/useBreadcrumbs';
import { PayrollContributionReportDetails } from '@/modules/Reports';

const PayrollContributionReportPage = () => {
  useBreadcrumbs([
    {
      route: ROUTES.NEW_REPORTS,
      title: 'Reports',
    },
    {
      route: ROUTES.PAYROLL_CONTRIBUTION_REPORT,
      title: 'Payroll Contributions',
    },
  ]);
  const isHasPermission = useHasAccess([
    {
      permission: PERMISSIONS.REPORTS,
    },
  ]);
  if (!isHasPermission) {
    return null;
  }

  return (
    <Box width="100%" data-testid="topbar-wrapper">
      <div>
        <Topbar />
      </div>
      <Box>
        <Box margin={{ top: 'spacing24' }}>
          <PayrollContributionReportDetails />
        </Box>
      </Box>
    </Box>
  );
};

export default PayrollContributionReportPage;
